import { render, staticRenderFns } from "./followlist.vue?vue&type=template&id=071302e9&scoped=true"
import script from "./followlist.vue?vue&type=script&lang=js"
export * from "./followlist.vue?vue&type=script&lang=js"
import style0 from "./followlist.vue?vue&type=style&index=0&id=071302e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071302e9",
  null
  
)

export default component.exports